var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import to from 'await-to-js';
import * as Sentry from '@sentry/browser';
import constants from '../constants/global-constants';
var generateIdentity = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!email)
            return [2 /*return*/, [{ success: false }, null]];
        return [2 /*return*/, to(Axios.get("".concat(constants.INTERNAL_API_BASE_URL, "/identity/generate"), {
                params: {
                    email: email,
                },
            }))];
    });
}); };
var getUser = function (accessToken, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var config, _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: accessToken,
                        'Cache-Control': 'max-age=0',
                    },
                };
                return [4 /*yield*/, auth0User.get({ user_id: userId })];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data ? data.data : null]];
        }
    });
}); };
var sandboxDbUser = {
    get: function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.get("".concat(constants.API_BASE_URL_v2, "/SandboxGetUserInfo"), {
                        headers: {
                            authorization: accessToken,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], response = _a[1];
                    return [2 /*return*/, [err, response ? response.data : null]];
            }
        });
    }); },
    update: function (body, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxSaveUserInfo"), JSON.stringify(body), {
                        headers: {
                            authorization: accessToken,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], response = _a[1];
                    return [2 /*return*/, [err, response]];
            }
        });
    }); },
};
var auth0User = {
    get: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.get("".concat(constants.INTERNAL_API_BASE_URL, "/user"), {
                        params: params,
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], data = _a[1];
                    return [2 /*return*/, [err, data]];
            }
        });
    }); },
    update: function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.patch("".concat(constants.INTERNAL_API_BASE_URL, "/user/app-metadata"), __assign({ product_name: 'sandboxv3' }, params)))];
                case 1:
                    _a = _b.sent(), err = _a[0], data = _a[1];
                    return [2 /*return*/, [err, data]];
            }
        });
    }); },
    updateUser: function (updateUserObject) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.patch("".concat(constants.INTERNAL_API_BASE_URL, "/user/update"), updateUserObject))];
                case 1:
                    _a = _b.sent(), err = _a[0], data = _a[1];
                    return [2 /*return*/, [err, data]];
            }
        });
    }); },
};
var getMarketoLead = function (filterType, filterValue, fields) {
    if (fields === void 0) { fields = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.get("".concat(constants.INTERNAL_API_BASE_URL, "/get/lead"), {
                        timeout: 10000,
                        params: {
                            filterType: filterType,
                            filterValue: filterValue,
                            fields: fields,
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], data = _a[1];
                    return [2 /*return*/, [err, data ? data.data : null]];
            }
        });
    });
};
var sendActivityToMarketo = function (leadId, eventName, meta) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.INTERNAL_API_BASE_URL, "/lead/activity"), __assign({ leadId: leadId, eventName: eventName }, meta)))];
            case 1:
                _a = _b.sent(), err = _a[0], data = _a[1];
                return [2 /*return*/, [err, data ? data.data : null]];
        }
    });
}); };
var hasAgreedToTerms = function (user) { return user.app_metadata.agreedToTermsAt; };
var sendVerificationEmail = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.INTERNAL_API_BASE_URL, "/user/verification"), {
                    user_id: userId,
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], response = _a[1];
                return [2 /*return*/, [err, response && response.data]];
        }
    });
}); };
var addConditionalLead = function (params, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.API_BASE_URL_v2, "/SandboxConditionalAddLead"), JSON.stringify(params), {
                    headers: {
                        Authorization: accessToken,
                    },
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                return [2 /*return*/, [err, res && res.data]];
        }
    });
}); };
var pushLead = function (user, programName) {
    if (programName === void 0) { programName = 'WBP Sandbox'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, err, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.INTERNAL_API_BASE_URL, "/lead/push"), {
                        lookupField: 'email',
                        programName: programName,
                        lead: {
                            email: user.email,
                            firstName: user.firstName ||
                                user.first_name ||
                                (user.user_metadata && user.user_metadata.first_name),
                            lastName: user.lastName ||
                                user.last_name ||
                                (user.user_metadata && user.user_metadata.last_name),
                        },
                    }))];
                case 1:
                    _a = _b.sent(), err = _a[0], res = _a[1];
                    if (err)
                        Sentry.captureException(err);
                    return [2 /*return*/, [err, res ? res.data : null]];
            }
        });
    });
};
var updateLead = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.INTERNAL_API_BASE_URL, "/lead/push"), {
                    lead: user,
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                if (err)
                    Sentry.captureException(err);
                return [2 /*return*/, [err, res ? res.data : null]];
        }
    });
}); };
var associateLead = function (leadId, cookie) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.INTERNAL_API_BASE_URL, "/lead/associate"), {
                    leadId: leadId,
                    cookie: cookie,
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                if (err)
                    Sentry.captureException(err);
                return [2 /*return*/, [err, res ? res.data : null]];
        }
    });
}); };
var sendWebLinkEmail = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, to(Axios.post("".concat(constants.NODE_API_BASE_URL, "/SandboxSendWebLinkEmail"), {
                    email: email,
                }))];
            case 1:
                _a = _b.sent(), err = _a[0], res = _a[1];
                return [2 /*return*/, [err, res ? res.data : null]];
        }
    });
}); };
export default {
    getUser: getUser,
    getMarketoLead: getMarketoLead,
    hasAgreedToTerms: hasAgreedToTerms,
    auth0User: auth0User,
    sendVerificationEmail: sendVerificationEmail,
    generateIdentity: generateIdentity,
    addConditionalLead: addConditionalLead,
    sendActivityToMarketo: sendActivityToMarketo,
    pushLead: pushLead,
    associateLead: associateLead,
    updateLead: updateLead,
    sandboxDbUser: sandboxDbUser,
    sendWebLinkEmail: sendWebLinkEmail,
};
